// extracted by css-extract-rspack-plugin
export default {"iconButton":"Gw4Bu","searchTextButton":"siit6","shortcutText":"K0fzS"};